// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"j9-z"};